var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 132.29 132.29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1070"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a10096",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44003a",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1034"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa200",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdf00",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1036",
    x1: 44.268,
    x2: 93.936,
    y1: 105.5,
    y2: 19.83,
    gradientTransform: "translate(-133.92 -123.43)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient1034"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1036-9",
    x1: 44.268,
    x2: 93.936,
    y1: 105.5,
    y2: 19.83,
    gradientTransform: "matrix(.85348 0 0 .85348 9.7543 8.3945)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient1034"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1072",
    x1: 60.36,
    x2: 75.963,
    y1: 94.299,
    y2: 31.115,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient1070"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1080",
    x1: 40.416,
    x2: 91.094,
    y1: 92.778,
    y2: 27.459,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient1034"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.287 -.17906)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1)",
    cx: -66.961,
    cy: -61.713,
    r: 48.785,
    fill: "url(#linearGradient1036)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.905,
    cy: 61.065,
    r: 41.637,
    fill: "url(#linearGradient1036-9)",
    strokeWidth: 0.707
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.662 32.839 3.1322 61.984 13.904 0.01963-1.7611-28.37c37.567-6.07 30.999-46.48-15.275-33.634z",
    fill: "url(#linearGradient1072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.77 39.147 1.028 19.497c22.318-4.4307 14.985-23.947-1.028-19.497z",
    fill: "url(#linearGradient1080)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.93 83.832 4.9258 34.288c4.2067 6.5326 38.022 4.4584 37.434 0.80736l7.1001-35.591c-3.0749-4.2328-45.597-5.0552-49.46 0.49546z",
    fill: "#9ba0a0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.02,
    cy: 84.208,
    rx: 22.604,
    ry: 2.8957,
    fill: "#66665f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.433 11.223-32.689 104.03-16.51-0.14923-5.2696 3.5635-0.30138 1.7492 1.444-0.0731 0.21567 6.886 2.0549-1.811 0.81342 1.8968 2.514-1.9219 0.2242 1.2738 2.6911-1.5611 0.37334 2.1067 2.7182-1.896-0.01445 2.5809 3.7247-3.0281 0.69737 2.8635 1.4467-2.3543-0.08446 2.9172 4.1457-3.3213-0.26919 3.2463 2.9987-2.6983 0.10576 2.9092 3.6174-3.2123 0.26012 2.8822 2.2279-2.1156-0.39776 2.9734 3.3968-3.3156-0.67253 3.2443 2.2723-3.1523 0.5402 3.1199 1.7966-2.795 0.81824 2.6299 1.5077-2.9432 1.064 0.80666 0.94584-1.7977 0.81265 0.88065-0.46782-6.4103 1.2567-1.0723 0.54049-2.7004-19.446-0.26352 32.166-102.71c0.53103-0.98879-2.0365-2.4289-3.2682-1.2594z",
    fill: "#414141"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "point",
    transform: "matrix(1.3067 0 0 1.3067 -20.987 -14.327)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1)",
    cx: -66.961,
    cy: -61.713,
    r: 48.785,
    fill: "url(#linearGradient1036)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.905,
    cy: 61.065,
    r: 41.637,
    fill: "url(#linearGradient1036-9)",
    strokeWidth: 0.707
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.662 32.839 3.1322 61.984 13.904 0.01963-1.7611-28.37c37.567-6.07 30.999-46.48-15.275-33.634z",
    fill: "url(#linearGradient1072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.77 39.147 1.028 19.497c22.318-4.4307 14.985-23.947-1.028-19.497z",
    fill: "url(#linearGradient1080)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m84.205 89.082c10.492 30.796 32.25 39.89 31.459 12.94",
    fill: "none",
    strokeWidth: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ce1a6899.svg";
export { ForwardRef as ReactComponent };